var React = require('react');

function Annotation (props) {
    return React.createElement("svg",props,[React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M.837 10.162C.749 5.1 4.939.924 10.002.835c5.061-.087 9.077 3.945 9.165 9.008.087 5.061-4.104 9.238-9.165 9.326-5.062.088-9.078-3.946-9.165-9.007zM10 9.17v5.834","key":0}),React.createElement("path",{"strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M9.585 5.837a.416.416 0 1 1 .832 0 .416.416 0 0 1-.832 0z","key":1})]);
}

Annotation.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Annotation;

Annotation.default = Annotation;
